import { render, staticRenderFns } from "./PointConfirmation.vue?vue&type=template&id=26aa09c4&scoped=true"
import script from "./PointConfirmation.vue?vue&type=script&lang=js"
export * from "./PointConfirmation.vue?vue&type=script&lang=js"
import style0 from "./PointConfirmation.vue?vue&type=style&index=0&id=26aa09c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26aa09c4",
  null
  
)

export default component.exports